const api = '/api/v1/u011_r_group_controller.php';
import axios from 'axios';
export const group_repository =  {
    get(user_id){
        return  axios.get(`${api}?USER_ID=${user_id}`);
    },
    upd(data){
        return  axios.post(api, data);
    }
};

